import { ProjectFinancialService } from './../../../services/projectFinancial.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Approval } from '../../../models/Approval.model';
import { CommonHelper } from '../../../shared/helpers/CommonHelper';
import { ApprovalService } from '../../../services/approval.service';
import { ConsultantService } from '../../../services/consultant.service';
import { Consultant } from '../../../models/Consultant.model';
import { Company } from '../../../models/Company.model';
import { ProjectToApproval } from '../../../models/ProjectToApproval.model';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Router } from '@angular/router';
import { ConsultantSearch } from '../../../models/ConsultantSearch.model';
import { ProjectSearch } from "../../../models/ProjectSearch.model";
import * as _ from "lodash";
import { DropDownList } from '../../../models/DropDownList.model';
import * as moment from 'moment';
import { LocalStorage } from '../../../shared/wrappers/LocalStorage';
import { GUARDS } from '../../../shared/auth/Roles';
import { ContractType } from '../../../shared/enums/ContractType';
import { AccountingPeriodBlock } from '../../../models/AccountingPeriodBlock.model';
import { AccountingPeriodBlockService } from "../../../services/accountingBlock.service";
import { isBlockPeriodInvalid } from '../../../shared/helpers/validate-block-period';
import { AccountingType } from '../../../shared/enums/AccountingBlockType';
import { ExcellenceCenter } from "../../../models/ExcellenceCenter.model";
import { ExcellenceCentersService } from "../../../services/excellenceCenters.service";


@Component({
  selector: 'app-approvals-create',
  templateUrl: './approvals-create.component.html',
  styleUrls: ['./approvals-create.component.scss']
})
export class ApprovalCreateComponent implements OnInit {
  @ViewChild('projectsMultiselect') projectsMultiselect;
  @ViewChild('consultantMultiselect') consultantMultiselect;

  consultantSearch: ConsultantSearch = new ConsultantSearch();
  approvals: any = [];
  approval: Approval = new Approval();
  commonHelper: CommonHelper = new CommonHelper();
  consultants: Consultant[] = new Array<Consultant>();
  companies: Company[] = new Array<Company>();
  selectedCompany;
  consultantSelected: any = [];
  projects: any = [];
  projectsByCompany: any = [];
  currentTotalHours: number = 0;
  currentProjectCustomer: any = null;
  currentDate: Date;
  addProjectCheck = false;
  totalHourValue = 0;
  totalSoldHourValue = 0;
  hourValue: any = 0;
  soldHourValue: any = 0;
  loading: boolean;
  selectedApprovalCompany;
  status: number = 0;
  ProjectList: Array<any> = [];
  filteredConsultantList: DropDownList[] = new Array<DropDownList>();
  errorList: Array<any> = [];
  successList: Array<any> = [];
  updatedList: Array<any> = [];
  selectDate: boolean = false;
  date: Date = null;
  competence: number = -1;
  competenceYear: number = -1;
  monthList;
  years;
  datePattern = /^(0[1-9]|1[0-9]|2[0-9]|3[01]).(0[1-9]|1[012]).[0-9]{4}$/i;
  mask = [/[0-3]/, /[0-9]/, '/', /[0-1]/, /[0-9]/, '/', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/];
  consultantsBorrowInvoice = [];
  user;

  dropDownListConsultants: DropDownList[] = new Array<DropDownList>();
  consultantsFiltered: DropDownList[] = new Array<DropDownList>();
  dropDownListProjects: DropDownList[] = new Array<DropDownList>();
  dropDownListCompanies: DropDownList[] = new Array<DropDownList>();
  dropDownListDivisions: DropDownList[] = new Array<DropDownList>();
  dropDownListExcellenceCenters: DropDownList[] = new Array<DropDownList>();

  selectedConsultantsItems: DropDownList[] = new Array<DropDownList>();
  selectedProjectsItems: DropDownList[] = new Array<DropDownList>();
  selectedCompaniesItems: DropDownList[] = new Array<DropDownList>();
  selectedDivisionsItems: DropDownList[] = new Array<DropDownList>();
  selectedExcellenceCentersItems: DropDownList[] = new Array<DropDownList>();

  dropDownConsultantsSettings = {};
  dropDownProjectsSettings = {};
  dropDownCompaniesSettings = {};
  dropDownDivisionsSettings = {};
  dropDownExcellenceCentersSettings = {};
  accountingBlock = new AccountingPeriodBlock();
  allExcellenceCenters: ExcellenceCenter[] = [];
  constructor(
    private approvalService: ApprovalService,
    private consultantService: ConsultantService,
    private projectFinancialService: ProjectFinancialService,
    public toastr: ToastsManager,
    public router: Router,
    private localStorage: LocalStorage,
    private accountingBlockService: AccountingPeriodBlockService,
    private excellenceCentersService: ExcellenceCentersService,
  ) { }

  async ngOnInit() {
    this.loading = true;
    this.accountingBlock = (await this.accountingBlockService.getAllBlockedPeriods())
        .find(({type}: AccountingPeriodBlock) => type === AccountingType.Approval);

    this.consultantSearch.limit = 99999;
    let consultantSearch = new ConsultantSearch();
    consultantSearch.onlyActives = false;
    consultantSearch.limit = 9999999;

    let projectSearch = new ProjectSearch();
    projectSearch.skip = 0;
    projectSearch.limit = 9999999;

    var response = await this.projectFinancialService.getProjectsAndCustomers();
    consultantSearch.fields = ["_id", "name", 'contract.kind', 'division', 'active', 'excellenceCenter'];

    this.consultants = await this.consultantService.searchConsultants(consultantSearch);

    const consultantsPJ = await this.consultantService.listAll();
    consultantsPJ.forEach(c => {
      if(c.sapCardCode != '' && c.contract && c.contract.cnpj != '' && c.contract.sapServiceCode != '')
        this.consultantsBorrowInvoice.push(c)
    })

    this.user = this.localStorage.retrieve('user');
    if (this.user.permission === GUARDS.DP) {
        this.consultants = this.consultants.filter(({contract}) => contract.kind !== ContractType.PJ)
    }

    this.consultants = _.orderBy(this.consultants, [consultant => consultant.name.toUpperCase()]);
    this.currentDate = new Date();
    this.companies = response.customers;
    this.projects = response.projects;
    this.projectsByCompany = this.projects;
    this.loading = false;
    this.approval.projects = [];

    const allExcellenceCenters = await this.excellenceCentersService.getAll();
    this.allExcellenceCenters = allExcellenceCenters.filter(ec => Number(ec.type) == 1);

    this.monthList = this.commonHelper.listAllMonths();
    this.years = this.commonHelper.listLastYears();

    this.dropDownConsultantsSettings = this.commonHelper.getDropDownSettings(false, 'Consultores', false, 'Marcar todos os consultores', 'Desmarcar todos os consultores', true,'active','', true);

    this.dropDownCompaniesSettings = this.commonHelper.getDropDownSettings(true, 'Clientes', false, 'Marcar todos os clientes', 'Desmarcar todos os clientes', true, null, '');
    this.dropDownProjectsSettings = this.commonHelper.getDropDownSettings(true, 'Projetos', false, 'Marcar todos os projetos', 'Desmarcar todos os projetos', true, null, '', true);
    this.dropDownDivisionsSettings = this.commonHelper.getDropDownSettings(true, 'Divisões', false, 'Marcar todas as divisões', 'Desmarcar todas as divisões', true, null, '');
    this.dropDownExcellenceCentersSettings = this.commonHelper.getDropDownSettings(true, 'Centros de excelência', false, 'Marcar todos os centros de excelência', 'Desmarcar todos os centros de excelência', true,null,'', false);

    this.dropDownListDivisions = this.commonHelper.getDropDownListItemsEnum(this.commonHelper.getAllGroups(), "GroupDivision");
    this.dropDownListConsultants = this.commonHelper.getDropDownListConsultant(this.consultants, "_id", "name", "contract.kind", 'division', 'active', 'excellenceCenter');
    this.dropDownListCompanies = this.commonHelper.getDropDownListItems(this.companies, "_id", "name");
    this.dropDownListProjects = this.commonHelper.getDropDownListItems(this.projects, "_id", "name");
    this.dropDownListExcellenceCenters = this.commonHelper.getDropDownListItems(this.allExcellenceCenters, "_id", "name");

    this.consultantsFiltered = this.dropDownListConsultants;
  }

  addProject() {
    let project = {
      customer: { financialId: null, financialName: null },
      projectFinancialId: null,
      name: null,
      total_hours: null,
      excellenceCenter: {_id:'', name:''},
      excellenceCenterList: []
    };

    project.customer.financialId = this.selectedApprovalCompany[0]._id;
    project.customer.financialName = this.selectedApprovalCompany[0].name;
    project.projectFinancialId = this.currentProjectCustomer[0]._id;
    project.name = this.currentProjectCustomer[0].name;
    project.total_hours = this.currentTotalHours;

    const excellenceCenterList = [...this.currentProjectCustomer[0].excellenceCenters];
    project.excellenceCenterList = excellenceCenterList;
    if(project.excellenceCenterList.length == 1) {
        project.excellenceCenter = {
            _id: project.excellenceCenterList[0]._id,
            name: project.excellenceCenterList[0].name
        }
    }
    this.ProjectList.push(project);

    this.currentTotalHours = 0;
    this.selectedCompany = null;
    this.currentProjectCustomer = null;
    this.selectedProjectsItems = null;
    this.projectsMultiselect.settings.disabled = true;
  }

  selectAll(event: any) {
    let element: any = document.querySelector('.c-input.ng-valid.ng-dirty.ng-touched')
    if (element != null && element.value) {
      let value = element.value;
      this.filterConsultantsByContract(value);
    }
  }

  async createNewApproval() {
    try {
      this.loading = true;
      if(this.competence >= 0 && this.competenceYear != -1) {
        const isInvalid = isBlockPeriodInvalid({
            competence: this.competence, competenceYear: this.competenceYear
        }, this.accountingBlock, true);
        if (isInvalid) {
            this.loading = false;
            return this.toastr.warning(`A competência
            ${(this.monthList.find((m: {number: number, name: string}) => Number(m.number) === Number(this.competence))).name.toLowerCase()}/${this.competenceYear},
                está dentro do intervalo de bloqueio. Por favor selecione
                uma data diferente antes de salvar a aprovação.`, 'Bloqueio Contábil', {
            toastLife:8000,
            showCloseButton: true
            });
        }
        this.approvals.forEach(approval => {
          let dateAux = new Date();
          dateAux.setDate(1);
          dateAux.setMonth(this.competence);
          dateAux.setFullYear(this.competenceYear);
          approval.date = dateAux.toISOString();
          approval.dateEdited = true;
        });
      }
      this.clearLists();
      for (let approval of this.approvals) {
        approval.approvedHours = approval.realizedHours;
        approval.status = this.status;
      };
      let responses = await this.approvalService.create(this.approvals);
      if(responses && responses.length > 0){
        if(responses[0].status == 400){
          let msg = JSON.parse(responses[0]._body);
          this.toastr.error(msg.message);
          this.approvals = [];
        } else {
          this.approvals = responses;
        }
      }

      this.loading = false;
      this.getReturnLists(responses);

    } catch (err) {
      console.log(err);
      this.toastr.error("Erro ao criar aprovação!")
    }

  }

  deleteProject(i: number) {
    this.ProjectList.splice(i, 1);
    this.onProjectChange()
  }

  changeExcellenceCenter(){
    this.consultantsFiltered = [];
    if(this.selectedExcellenceCentersItems.length > 0){
      this.consultantsFiltered = _.filter(this.dropDownListConsultants, item => {
        return item.excellenceCenter == this.selectedExcellenceCentersItems[0].id;
      });
      this.consultantMultiselect.settings.disabled = false;
    } else {
      this.consultantMultiselect.settings.disabled = true;
    }
  }

  getReturnLists(responses) {
    this.errorList = _.filter(responses, { success: false });
    this.successList = _.filter(responses, { success: true, updated: false });
    this.updatedList = _.filter(responses, { updated: true });
  }

  clearLists() {
    this.errorList = [];
    this.successList = [];
    this.updatedList = [];
  }

  removeSuccess() {
    _.remove(this.approvals, (approval) => { return (approval.updated == false && approval.success == true) });
    this.successList = [];
  }

  removeUpdated() {
    _.remove(this.approvals, (approval) => approval.updated == true);
    this.updatedList = [];
  }

  async search() {
    this.loading = true;
    let reminder = false;
    let approvals = [];
    let ids = [];
    if (this.consultantSelected.length > 0) {
      for (let item of this.consultantSelected) {
        ids.push(item.id);
      }

      this.consultantSearch._id = ids;
      let consultants = await this.consultantService.searchConsultants(this.consultantSearch);
      for (let consultant of consultants) {
        let approval = new Approval();
        approval.consultant.loadToApproval(consultant);
        approval.projects = _.cloneDeep(this.ProjectList);
        approval['success'] = null;
        approval['updated'] = false;
        approvals.push(approval);

        if(consultant.contract.kind == 1 && consultant.contract.honorarium == 2)
          reminder = true;
      }
      this.approvals = approvals;

      this.onProjectChange();

      this.selectedDivisionsItems = [];
    }

    if(reminder)
        this.toastr.info("Utilize as opções 'HORAS EXTRAS' ou 'DESCONTAR HORAS' quando o valor total da aprovação for diferente do valor de contrato do consultor",'Lembrete');

    this.loading = false;
  }

  OnCancel() {
    this.selectedCompany = null;
    this.consultantSelected = null;
    this.selectedDivisionsItems = null;
    this.ProjectList = [];
    this.currentTotalHours = 0;
    this.currentProjectCustomer = null;
    this.hourValue = 0;
    this.soldHourValue = 0;
    this.totalHourValue = 0;
    this.totalSoldHourValue = 0;
    this.approvals = [];
    this.competence = -1;
    this.competenceYear = -1;
    this.selectedProjectsItems = new Array<DropDownList>();
    this.clearLists();
  }

  removeApproval(id) {
    _.remove(this.approvals, (approval) => {
      return approval.consultant._id == id;
    });
  }

  onProjectChange() {

    for (let approval of this.approvals) {
      approval.realizedHours = 0;
      approval.totalHourValue = 0;
      approval.totalSoldHourValue = 0;
      approval.projects.map(item => {
        approval.realizedHours += item.total_hours;
        item.approvedHours = item.total_hours;
        item.approvedValue = this.valueCheck(item.total_hours * approval.consultant.contract.hourValue, approval.consultant.contract.totalValue.valueOf()) ? approval.consultant.contract.totalValue.valueOf() : item.total_hours * approval.consultant.contract.hourValue;
        approval.totalHourValue = approval.consultant.contract.hourValue.valueOf() * approval.realizedHours;
        approval.totalValue = this.valueCheck(approval.totalHourValue, approval.consultant.contract.totalValue.valueOf()) ? approval.consultant.contract.totalValue.valueOf() : approval.totalHourValue;
        approval.totalSoldHourValue = approval.consultant.contract.soldHourValue ? approval.consultant.contract.soldHourValue.valueOf() * approval.realizedHours : 0;
      });
    }

  }

  clear() {
    this.consultantSelected = [];
    this.approvals = [];
  }

  changeCustomer() {
    if (this.selectedCompany.length > 0) {
      this.selectedApprovalCompany = _.filter(this.companies, { _id: this.selectedCompany[0].id });
      this.dropDownListProjects = this.commonHelper.getDropDownListItems(this.projects.filter(x => x.companyId == this.selectedCompany[0].id), "_id", "name");
      this.projectsMultiselect.settings.disabled = false;
    } else {
        this.projectsMultiselect.settings.disabled = true;
    }
  }

  changeProject() {
    if (this.selectedProjectsItems.length > 0) {
      this.currentProjectCustomer = _.filter(this.projects, { _id: this.selectedProjectsItems[0].id });
    }
  }

  valueCheck(projectHours, totalValue) {
    if (Math.abs(projectHours - totalValue) <= 1) {
      return true;
    }
    return false;
  }

  filterConsultantsByContract(value) {
    switch (value.toUpperCase()) {
      case 'PJ':
        this.consultantSelected = _.filter(this.consultantsFiltered, item => {
          return item.kind == 'PJ';
        });
        break;
      case 'CLT':
        this.consultantSelected = _.filter(this.consultantsFiltered, item => {
          return item.kind == 'CLT';
        });
        break;
      case 'OUTROS':
        this.consultantSelected = _.filter(this.consultantsFiltered, item => {
          return item.kind == 'Outros';
        });
        break;
      case 'ESTAGIÁRIO':
        this.consultantSelected = _.filter(this.consultantsFiltered, item => {
          return item.kind == 'Estagiário';
        });
        break;

      default:
        return
    }

  }

  filterByDivision() {
    if (this.selectedDivisionsItems.length > 0) {
      this.consultantsFiltered = _.filter(this.dropDownListConsultants, item => {
        return item.division == this.selectedDivisionsItems[0].itemName;
      });
      this.consultantMultiselect.settings.disabled = false;
    }

  }

  verifyDate(date) {
    if (!(new RegExp(this.datePattern).test(date))) {
      this.toastr.warning(`Digite uma data válida.`, "Data inválida!");
      this.date = null;
    }
  }

  get verifyNullDate() {
    return (this.date && this.selectDate)
  }

}



// WEBPACK FOOTER //
// ./src/app/views/approvals/approvals-create/approvals-create.component.ts